export class CommonSettings {
	startup = {
		student: {
			activeStudentSettingID: null,
			activeStudentGuardFallbackRoute: '/invalid-state',
			noStudentGuardFallbackRoute: '/',
		},
	};

	templates = {
		global: {
			currentTime: {
				intervalTime: 250,
			},
		},
	};

	views = {
		student: {
			gateLockoutDelaySeconds: 5,
			speedbumpHideSeconds: 60 * 60 * 18 * 1 /* 18 hours */,
		},
		gabby: {
			main: {
				titleNotificationDelay: 1000,
			},
			chat: {
				timestampThreshold: 15 * 60 * 1000,
				scrollEdgeBuffer: 500,
				autoResponseTimeout: 60 * 60 * 1000,
			},
			message: {
				maxBodyLength: 2000,
				maxAttachmentSize: 1048576 * 2, // 2MB
				maxAttachmentCount: 5,
				attachmentExtensionFilter: '.png,.jpg,.jpeg,.gif,image/*',
			},
		},
	};

	services = {
		authenticationCheck: {
			normalCheckInterval: 1000 * 60 /* 1 minute */,
			panicCheckInterval: 5000 /* 5 seconds */,
			awayCheckInterval: 1000 * 60 * 10 /* 10 minutes */,
		},
		store: {
			message: {
				loadcount: 15,
			},
			channel: {
				pageSize: 20,
			},
		},
		techBanners: {
			buildVersion: {
				checkInterval: 60000 * 30 /* 30 minutes */,
			},
		},
		utilities: {
			userActive: {
				inactiveDelay: 10 * 1000 /* 10 seconds */,
				awayDelay: 10 * 60 * 1000 /* 10 minutes */,
				checkLongPollInterval: 60 * 1000 /* 1 minute */,
				checkResponsivePollInterval: 1000 /* 1 second */,
			},
			profileFileSize: 1048576 * 2, // 1MB
			studentUploadSize: 1048576 * 20, // 20MB
		},
		websocket: {
			connectionTimeout: 5 * 1000 /* 5 seconds */,
			connectionKeepAlive: 60 * 1000 /* 1 minute */,
			connectionKeepAlivePresence: 15 * 60 * 1000 /* 15 minutes */,
			gabby: {
				readChannelDelay: 2.5 * 1000 /* 2.5 seconds */,
				unreadDelay: 5 * 1000 /* 5 seconds */,
				typingActivityTimeout: 15 * 1000 /* 15 seconds */,
			},
		},
	};
}
